// extracted by mini-css-extract-plugin
module.exports = {"section":"work-process-module--section--2GDT2","bullets":"work-process-module--bullets--3Ry8s choose-integration-module--bullets--GR1G7"};